import { createFileRoute } from '@tanstack/react-router';
import { Banners } from '@/features/banners/componentes/Banners';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Banners da Home do app (spec 024). */
export const Route = createFileRoute('/_autenticado/banners/')({
  ...rotaDeTela('banners.lista'),
  component: Banners,
});
